import React from 'react';
import { Trans } from 'react-i18next';

import CheckBoxCmp from '@/components/CheckBox';
import FormTitleSession from '@/components/FormTitleSession';
import { validations } from '@/utils/fields';

const cancelConfirmTranslate = <Trans i18nKey={'proposalRequest:proposalRequest.form.partners.goods.form.help'}
  components={{ br: <br/> }}/>;

export const fields = [
  {
    key: 'administration',
    // eslint-disable-next-line react/display-name
    render: () => <FormTitleSession translate={'proposalRequest'}
      title={'proposalRequest.form.partners.goods.form.title'}
      customDescription={cancelConfirmTranslate}/>
  },
  {
    label: 'proposalRequest.form.partners.goods.name.placeholder',
    key: 'name',
    colSpan: 1.5,
    required: true,
    widgetProps: {
      size: 'large'
    },
    rules: [validations.text()]
  },
  {
    label: 'proposalRequest.form.partners.goods.monetaryValuation.placeholder',
    key: 'monetaryValuation',
    widget: 'number',
    widgetProps: {
      size: 'large',
      formatter: (value) => value ? `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '',
      parser: (value) => value.replace(/\$\s?|(,*)/g, ''),
      type: 'text'
    },
    rules: [validations.valueNotZero()],
    required: true,
    colSpan: 1.5,
  },
  {
    key: 'description',
    label: 'description',
    onlyEdit: true,
    colSpan: 3,
    widget: 'textarea',
    widgetProps: {
      size: 'large',
      autoSize: { minRows: 5, maxRows: 12 }
    },
    required: false,
    className: 'form-view-mode-vertical-item',
    rules: [validations.descriptionLength()]
  },
  {
    key: 'isCommon',
    widget: CheckBoxCmp,
    noStyle: true,
    initialValue: false,
    widgetProps: {
      size: 'large',
      required: false,
      translate: 'proposalRequest',
      title: 'proposalRequest.form.partners.goods.isMatrimonialCommunity.question',
    }
  },
  {
    key: 'isRight',
    widget: CheckBoxCmp,
    initialValue: false,
    noStyle: true,
    widgetProps: {
      required: false,
      size: 'large',
      translate: 'proposalRequest',
      title: 'proposalRequest.form.partners.goods.isRight.question',
    }
  }
];
